import React from 'react';

import { useTranslation } from '@crehana/i18n';

import useCatalogSearchCourses from 'Jsx/Catalog/hooks/useCatalogSearchCourses';

import CourseListSlider from './CourseListSlider';

const CommunityNew = () => {
  const { t } = useTranslation();
  const { courses, loading, error } = useCatalogSearchCourses({
    minCourses: 6,
  });

  if (error) {
    return (
      <div className="py-24 mb-0">
        <span className="font-subtitle4 text-base-main">
          Ocurrió un error al intentar obtener los cursos recomendados, intente
          recargar la página.
        </span>
      </div>
    );
  }

  return (
    <CourseListSlider
      courses={courses}
      title={t('COURSE_NEW')}
      loading={loading}
      link="/cursos-nuevos/"
      linkText={t('COURSE_WATCH_MORE_2')}
    />
  );
};

export default CommunityNew;
